import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
// assets
import styles from '@/components/Layout/components/Navigation/components/NavigationItem/NavigationItem.module.css';

interface NavigationItemProps {
    className?: string;
    label: string;
    icon: React.ReactNode;
    path: string;
    supIcon: React.ReactNode;
}

const NavigationItem = ({
    className,
    label,
    icon,
    path,
    supIcon
}: NavigationItemProps) => {
    return (
        <NavLink
            className={({ isActive }) =>
                clsx(styles.navItem, className, {
                    [styles.isActive]: isActive
                })
            }
            to={path}
        >
            {icon}
            <span className="block leading-none">{label}</span>

            {supIcon ? (
                <span className={styles.sup}>{supIcon}</span>
            ) : undefined}
        </NavLink>
    );
};

export default NavigationItem;
